function closeNavigation() {
    document.getElementById("mobile-navigation").style.display = "none";
}

export default function MobileNavigation() {
    return (
        <div id = "mobile-navigation" style = {{position: 'absolute', backgroundColor: '#161616', width: '100vw', left: '0', height: '100vh', top: '0'}}>
            <div style = {{marginLeft: '20px', display: 'grid', marginTop: '100px', gap: '20px'}}>
                <a href = "/resources">Resources</a>
                <a href = "/about">About</a>
                <a href = "/chat">Chat</a>
            </div>
            <div id = "navigation-x" style = {{position: 'absolute', top: '20px', right: '20px'}}>
                <a href = "#" id = "navbar-x" onClick = {closeNavigation}>
                    <div className = "hamburger-line" style = {{rotate: '45deg', marginBottom: '-2px'}}></div>
                    <div className = "hamburger-line" style = {{rotate: '-45deg'}}></div>
                </a>
            </div>
        </div>
    )
}